import { ApiError, getJson, postJson } from './authApi';
export { ApiError };
export async function fetchAvailability(placeId, date) {
    return getJson(`/api/booking/availability?place=${placeId}&date=${date}`);
}
export async function fetchSubscriptionBalance(placeId) {
    return getJson(`/api/booking/subscription?place=${placeId}`);
}
export async function createBooking(payload) {
    return postJson('/api/booking/create', payload);
}
export async function fetchMyBookings(lang) {
    return getJson(`/api/booking/my-bookings?lang=${lang}`);
}
export async function cancelBooking(payload) {
    return postJson('/api/booking/cancel', payload);
}
